import {valueTypes } from '../helpers/enums'
let stored_balances = []
let zero_balance =  {money_type: 0, amount: 0, currency_id: 0}

export function GetAccountsWithBalances(accounts){

	if(!stored_balances.length)
        return accounts
       
    for (let index = 0; index < accounts.length; index++) {
		
		let balance = stored_balances.find(c=>c.id == accounts[index].id)?.account_statement_summary
        if(balance)
			accounts[index] = {...accounts[index], account_statement_summary: balance } // Replace with new one
        else
			accounts[index] = {...accounts[index], account_statement_summary: zero_balance } // assigne zero balance
	}

    return accounts
}

export function UpdateAccountsBalancses(balances){
	if(!balances.length)
	{
		console.warn("[Reformer] response of balances undefined, Failed to update accounts balances");
		return;
	}
	stored_balances = JSON.parse(JSON.stringify(balances))
}
export function changeValueType(data, type) {
	/*json and date returned value could be wrong */
	if([valueTypes.integer , valueTypes.double].includes(type))
		return +data;
	if(type === valueTypes.boolean)
		return data === 'true';
	if(type === valueTypes.string)
		return JSON.stringify(data);
	if(type === valueTypes.dateTime)
		return new Date(data);
	if(type === valueTypes.json)
		return JSON.parse(JSON.stringify(data))
}